import React, { Component } from "react";

import StartedFinishedTimeChart from "./charts/StartedFinishedTimeChart";
import PomsPerDayChart from "./charts/PomsPerDayChart";
import TotalPomsChart from "./charts/TotalPomsChart";
import TimesByDayChart from "./charts/TimesByDayChart";
import WorkEfficiencyChart from "./charts/WorkEfficiencyChart";
import PomCalendar from "./charts/PomCalendar";
import MonkeyPointsChart from "./charts/MonkeyPointsChart";

class PomTracker extends Component {
  filteredPoms({ poms = [], after }) {
    return poms.filter(pom => pom.start > after);
  }

  render() {
    let { poms, points } = this.props;

    poms = this.filteredPoms({ poms, after: new Date("2018-01-01") });

    const renderPoms = poms && poms.length !== 0;

    return (
      <div>
        {points && <MonkeyPointsChart points={points} />}
        {renderPoms && <TotalPomsChart poms={poms} />}
        {renderPoms && <StartedFinishedTimeChart poms={poms} />}
        {renderPoms && <TimesByDayChart poms={poms} />}
        {renderPoms && <WorkEfficiencyChart poms={poms} />}
        {/* {renderPoms && <PomsPerDayChart poms={poms} />} */}
        {renderPoms && <PomCalendar poms={poms} />}
        {/*<pre>{JSON.stringify(this.props.poms, null, 2)}</pre>*/}
      </div>
    );
  }
}

export default PomTracker;

// export default compose(
//   firestoreConnect(props => {
//     // console.info("firestoreConnect:");
//     // console.log(props);
//     return [
//       // { collection: "todos", doc: props.todoId } // or `todos/${props.todoId}`
//       {
//         collection: `pomtrackers/zAUmzWCANTRolPhn33kV6HsmKmY2/poms/`,
//         queryParams: ["orderByKey", "limitToFirst=50"],
//       },
//       { collection: `pomtrackers/zAUmzWCANTRolPhn33kV6HsmKmY2/points/` },
//     ];
//   }),
//   connect(({ firestore: { ordered } }, props) => {
//     // console.dir({ ordered, props });
//     return {
//       poms:
//         ordered && ordered["pomtrackers/zAUmzWCANTRolPhn33kV6HsmKmY2/poms/"],
//       points:
//         ordered && ordered["pomtrackers/zAUmzWCANTRolPhn33kV6HsmKmY2/points/"],
//     };
//   })
// )(PomTracker);
//
// // export default PomTracker;



// WEBPACK FOOTER //
// ./src/PomTracker.js